module.exports = __webpack_public_path__ + "img/2.326d9da6.jpeg";